<div class="flex flex-col h-screen relative">
  <!-- Overlay de inicialização: cobre a tela enquanto carrega autenticação/contexto -->
  <div *ngIf="isInitializing"
       class="fixed inset-0 z-[10000] flex items-center justify-center bg-white dark:bg-gray-900">
    <div class="flex flex-col items-center space-y-4">
      <div class="w-12 h-12 border-4 border-betha-blue border-t-transparent rounded-full animate-spin"></div>
      <p class="text-gray-600 dark:text-gray-400 text-sm font-medium">Carregando...</p>
    </div>
  </div>

  <!-- Toast de Notificação Global (no topo) -->
  <app-notification-toast></app-notification-toast>

  <!-- Modal de Loading Global -->
  <app-loading-modal></app-loading-modal>

  <!-- Header estilo Betha -->
  <header class="bg-betha-blue text-white shadow-md relative z-30 shrink-0">
    <div class="flex items-center justify-between px-4 py-3">
      <div class="flex items-center gap-2">
        <button class="text-white hover:bg-white/10 p-1.5 rounded transition-colors" 
                (click)="toggleMenu()"
                title="Menu">
          <lucide-icon [name]="menuAberto ? 'chevron-left' : 'menu'" class="w-6 h-6"></lucide-icon>
        </button>
        <img src="assets/logo.png" alt="Logo" class="h-7 w-auto">
      </div>
    </div>
  </header>
  
  <!-- Wrapper para o conteúdo (sidebar + main) -->
  <div class="flex-1 flex flex-col relative overflow-hidden">
    <app-sidebar class="absolute inset-0 z-40 pointer-events-none"
      [class.pointer-events-auto]="menuAberto"
      [isOpen]="menuAberto"
      [contexto]="contexto"
      [contextActionLabel]="contextActionLabel"
      [userPhoto]="getUserPhoto()"
      [userName]="getNomeProfessor()"
      [userLogin]="getUsername()"
      [planoEnsinoDisponivel]="planoEnsinoDisponivel"
      (closeMenu)="toggleMenu()"
      (abrirContexto)="abrirModalContexto()"
      (abrirConfiguracoes)="abrirModalConfiguracoes()"
      (logout)="onLogout()"
    ></app-sidebar>

    <main class="flex-1 overflow-auto relative z-10 bg-gray-50 dark:bg-gray-900">
    <!-- Card de contexto global (visível em todas as páginas) -->
    <app-context-card></app-context-card>
    <!-- Empty state: fora do card, imediatamente abaixo -->
    <div
      *ngIf="!isInitializing && !isContextValid"
      id="contexto-empty-state-prompt"
      class="mx-3 mb-3 space-y-3"
    >
      <app-context-cancel-alert></app-context-cancel-alert>
      <button
        id="contexto-selecionar-btn"
        type="button"
        (click)="abrirModalContexto()"
        class="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-gradient-to-r from-blue-500 to-blue-600 dark:from-blue-600 dark:to-blue-700 hover:from-blue-600 hover:to-blue-700 dark:hover:from-blue-700 dark:hover:to-blue-800 text-white rounded-lg transition-all duration-200 shadow-sm font-medium text-sm"
        aria-label="Escolher contexto"
      >
        <lucide-icon name="arrow-left-right" class="w-4 h-4" aria-hidden="true"></lucide-icon>
        <span>Escolher contexto</span>
      </button>
    </div>
    <router-outlet></router-outlet>
  </main>
  </div>

  <app-install-prompt></app-install-prompt>
  
  <!-- Modal de perfil do usuário -->
  <app-user-profile-modal
    [isOpen]="userProfileOpen"
    (fechado)="userProfileOpen = false"
    (openConta)="onOpenConta()"
    (logout)="onLogout()"
  ></app-user-profile-modal>

  <!-- Modal de seleção de contexto -->
  <app-context-selector-modal
    [isOpen]="contextSelectorOpen"
    [canClose]="isContextValid"
    (fechado)="contextSelectorOpen = false"
    (contextChanged)="onContextChanged($event)"
  ></app-context-selector-modal>

  <!-- Modal de configurações -->
  <app-settings-modal #settingsModal></app-settings-modal>

  <!-- Modal de sem permissão (403) -->
  <app-sem-permissao-modal
    [isOpen]="semPermissaoOpen"
    (fechado)="semPermissaoOpen = false"
    (trocarContexto)="onSemPermissaoTrocarContexto()"
  ></app-sem-permissao-modal>
</div>
